import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { replace } from "react-router-redux";
import { reduxForm, formValueSelector } from "redux-form";

import FormPlaylist from "../form/FormPlaylist";

import Loading from "../../utils/loading/Loading";
import Retry from "../../utils/retry/Retry";

import { updatePlaylistRequest, updatePlaylistDone } from "./actions";
import { getPlaylistsRequest } from "../actions";

class AddPlaylist extends React.Component {
  static propTypes = {
    playlists: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      playlists: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        })
      ),
    }).isRequired,
    videos: PropTypes.shape({
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      videos: PropTypes.arrayOf(
        PropTypes.shape({
          videoTitle: PropTypes.string.isRequired,
          description: PropTypes.string,
          id: PropTypes.string.isRequired,
          file: PropTypes.string.isRequired,
          duration: PropTypes.number,
        })
      ),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    "update-playlist": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
    }).isRequired,
    updatePlaylistRequest: PropTypes.func.isRequired,
    getPlaylistsRequest: PropTypes.func.isRequired,
    updatePlaylistDone: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    playlistModel: PropTypes.string,
    match: PropTypes.shape({
      params: PropTypes.objectOf(PropTypes.any).isRequired,
    }).isRequired,
  };

  static defaultProps = {
    playlistModel: "Aucun",
  };

  state = {
    isMobile: false,
  };

  componentDidMount() {
    if (typeof this.props.playlists.playlists === "undefined") {
      this.getPlaylists();
    }
    this.setState({ isMobile: window.innerWidth < 1200 });
    window.addEventListener(
      "resize",
      () => {
        this.setState({ isMobile: window.innerWidth < 1200 ? true : false });
      },
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.playlistModel !== this.props.playlistModel) {
      this.handleModelUpdate(nextProps.playlistModel);
    }
  }

  componentWillUnmount() {
    this.props.updatePlaylistDone();
  }

  getPlaylists = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.getPlaylistsRequest({ accessToken, userId });
  };

  submit = (values) => {
    const { id: accessToken, userId } = this.props.login.authData;
    const { id: playlistId } = this.props.match.params;
    this.props.updatePlaylistRequest({
      values,
      videos: this.props.videos.videos,
      accessToken,
      userId,
      playlistId,
    });
  };

  handleModelUpdate = (model) => {
    const {
      playlists: { playlists },
    } = this.props;

    const playlist = playlists.find(({ id }) => id === model);

    if (typeof playlist === "undefined") {
      this.props.initialize({ model: "Aucun" });
    } else {
      const initialValues = {
        model: playlist.id,
        title: playlist.title,
        description: playlist.description,
      };

      this.props.initialize(initialValues);
    }
  };

  handleRetry = () => {
    this.getPlaylists();
  };

  render() {
    const {
      handleSubmit,
      playlistModel,
      playlists: {
        requesting: getPlaylistsRequesting,
        successful: getPlaylistsSuccessful,
        error,
        playlists,
      },
      videos: { requesting: getVideosRequesting, error: getVideosError },
      "update-playlist": {
        requesting: updatePlaylistRequesting,
        successful: updatePlaylistSuccessful,
      },
    } = this.props;

    return (
      <Fragment>
        {getPlaylistsRequesting && <Loading size={80} />}
        {getPlaylistsSuccessful && (
          <FormPlaylist
            title="Éditer playlist"
            playlists={playlists}
            handleOnSubmit={handleSubmit(this.submit)}
            requesting={updatePlaylistRequesting}
            successful={updatePlaylistSuccessful}
            selectedPlaylistId={playlistModel}
            preventSubmit={getVideosRequesting || getVideosError}
            isMobile={this.state.isMobile}
          />
        )}
        {error && <Retry message={error} onRetry={this.handleRetry} />}
      </Fragment>
    );
  }
}

const selector = formValueSelector("update-playlist");
const mapStateToProps = (state, props) => {
  const { id: playlistId } = props.match.params;
  let updatedPlaylist;
  if (state.playlists.playlists) {
    updatedPlaylist = state.playlists.playlists.find(
      ({ id }) => id === playlistId
    );
  }

  return {
    playlists: state.playlists,
    videos: state.videos,
    login: state.login,
    "update-playlist": state["update-playlist"],
    playlistModel: selector(state, "model"),
    initialValues: updatedPlaylist
      ? { model: updatedPlaylist.id }
      : {
          model: "Aucun",
        },
  };
};

const AddPlaylistForm = reduxForm({
  form: "update-playlist",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(AddPlaylist);

export default connect(mapStateToProps, {
  updatePlaylistRequest,
  updatePlaylistDone,
  getPlaylistsRequest,
  navigateTo: replace,
})(AddPlaylistForm);



// WEBPACK FOOTER //
// ./src/pages/playlists/update/UpdatePlaylist.jsx